
<template>
  <div class="container">
    <h1>{{ $t('home.infrared.title') }}</h1>

    <div class="section">
      <h2>{{ $t('home.infrared.structureTitle') }}</h2>
      <div class="device-tags">
        <span
          v-for="(device, idx) in $t('home.infrared.devices', { returnObjects: true })"
          :key="idx"
          class="device-tag"
        >
          {{ device }}
        </span>
      </div>

      <div v-for="(component, idx) in $t('home.infrared.components', { returnObjects: true })" :key="idx">
        <h3>{{ component.title }}</h3>
        <p>{{ component.desc }}</p>
      </div>
    </div>

    <div class="section">
      <h2>{{ $t('home.infrared.scenarioTitle') }}</h2>

      <div class="scenario" v-for="(sc, sIdx) in $t('home.infrared.scenarios', { returnObjects: true })" :key="sIdx">
        <div class="scenario-title">{{ sc.title }}</div>
        <div class="scenario-flow">{{ sc.flow }}</div>
      </div>
    </div>

    <div class="section">
      <h2>{{ $t('home.infrared.advantagesTitle') }}</h2>
      <ul>
        <li v-for="(adv, aIdx) in $t('home.infrared.advantages', { returnObjects: true })" :key="aIdx">
          {{ adv }}
        </li>
      </ul>
    </div>

    <div class="section">
      <h2>{{ $t('home.infrared.tipsTitle') }}</h2>
      <ul>
        <li v-for="(tip, tIdx) in $t('home.infrared.tips', { returnObjects: true })" :key="tIdx">
          {{ tip }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfraredControlSolution',
};
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
h1, h2, h3 {
  color: #2c3e50;
  margin-bottom: 12px;
}
p {
  margin-bottom: 12px;
}
.device-tags {
  margin: 12px 0;
}
.device-tag {
  display: inline-block;
  padding: 6px 12px;
  font-size: 0.9rem;
  color: #fff;
  background: #67c23a;
  border-radius: 4px;
  margin-right: 8px;
  margin-bottom: 6px;
}
.section {
  margin-bottom: 24px;
}
.scenario-title {
  font-weight: bold;
  margin-bottom: 6px;
}
.scenario-flow {
  padding: 10px 12px;
  background: #f0f9eb;
  border-left: 4px solid #67c23a;
  border-radius: 4px;
}
@media (max-width: 600px) {
  .container {
    margin: 0 10px;
    padding: 10px;
  }
  .device-tag {
    padding: 4px 8px;
    font-size: 0.85rem;
  }
}
</style>
